module.exports = __webpack_public_path__ + "img/Dijon.0dd0f3e1.png";